import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';

const MentorLog = ({ mentorLog, mentorLogSummary, mentorName }) => {
  const hasMentorLog =
    typeof mentorLog === 'string' && mentorLog.trim().length > 0;
  const hasMentorLogSummary =
    typeof mentorLogSummary === 'string' &&
    mentorLogSummary.trim().length > 0;
  const hasMentorLogContent = hasMentorLog || hasMentorLogSummary;

  return (
    <Grid container className="mentor-log">
      <Grid item xs={12}>
        <div className="mentor-log__heading">
          <h3>Bitácora post-sesión</h3>
          <p>
            Registro de la sesión escrito por {mentorName || 'el mentor'}.
          </p>
        </div>

        {hasMentorLogContent ? (
          <div className="mentor-log__content">
            {hasMentorLogSummary ? (
              <div className="mentor-log__section">
                <h4>Resumen de la bitácora</h4>
                <p>{mentorLogSummary}</p>
              </div>
            ) : null}
            {hasMentorLog ? (
              <div className="mentor-log__section">
                <h4>Registro de la mentoría</h4>
                <p>{mentorLog}</p>
              </div>
            ) : null}
          </div>
        ) : (
          <div className="mentor-log__empty" role="status">
            <p>El mentor aún no ha registrado una bitácora para esta sesión.</p>
          </div>
        )}
      </Grid>
    </Grid>
  );
};

MentorLog.propTypes = {
  mentorLog: PropTypes.string,
  mentorLogSummary: PropTypes.string,
  mentorName: PropTypes.string,
};

export default MentorLog;
